module.exports = __webpack_public_path__ + "dab8010fe75bd6584a4898346ae6f9a0.svg";